import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import * as fromCharge from './reducer'
import { ChargeEffects } from './effects'
import { ChargeService } from './service'
import { ChargesGuard } from './guard'

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('charge', fromCharge.chargeReducer),
    EffectsModule.forFeature([ChargeEffects]),
  ],
  declarations: [],
  providers: [ChargesGuard, ChargeService],
})
export class ChargesStoreModule {}
